import { Box, FormControl, FormHelperText, FormLabel, Grid, TextField } from '@mui/material'
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker'
import { DatePicker, DateTimePicker, TimePicker } from "@mui/x-date-pickers-pro";
import React from 'react'

/*const ProSpan = styled('span')({
	display: 'inline-block',
	height: '1em',
	width: '1em',
	verticalAlign: 'middle',
	marginLeft: '0.3em',
	marginBottom: '0.08em',
	backgroundSize: 'contain',
	backgroundRepeat: 'no-repeat',
	backgroundImage: 'url(https://mui.com/static/x/pro.svg)',
});*/

/*function Label({componentName, valueType, isProOnly}) {
	const content = (
		<span>
      <strong>{componentName}</strong> for {valueType} editing
    </span>
	);
	
	if (isProOnly) {
		return (
			<Stack direction="row" spacing={0.5} component="span">
				<Tooltip title="Included on Pro package">
					<a
						href="https://mui.com/x/introduction/licensing/#pro-plan"
						aria-label="Included on Pro package"
					>
						<ProSpan/>
					</a>
				</Tooltip>
				{content}
			</Stack>
		);
	}
	
	return content;
}*/

const DateTimePickers = () => {
    return (
        <Box>
            <h3>Standard</h3>
            <Grid
                container
                spacing={3}
            >
                <Grid item>
                    <FormControl>
                        <FormLabel>{('Description')}</FormLabel>
                        <DatePicker
                            sx={{ maxWidth: 160 }}
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'standard' } }}
                            name="EstimStartDt"
                            views={['year', 'month', 'day']}
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            textField={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                />}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl>
                        <FormLabel>{('Disabled')}</FormLabel>
                        <DatePicker
                            sx={{ maxWidth: 160 }}
                            disabled
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'standard' } }}
                            name="EstimStartDt"
                            views={['year', 'month', 'day']}
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            textField={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                />}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl>
                        <FormLabel>{('Read Only')}</FormLabel>
                        <DatePicker
                            sx={{ maxWidth: 160 }}
                            readOnly
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'standard' } }}
                            name="EstimStartDt"
                            views={['year', 'month', 'day']}
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            textField={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                />}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl required>
                        <FormLabel>{('Required')}</FormLabel>
                        <DatePicker
                            sx={{ maxWidth: 160 }}
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'standard' } }}
                            name="EstimStartDt"
                            views={['year', 'month', 'day']}
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            textField={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                />}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl
                        required
                        error={true}
                    >
                        <FormLabel>{('Error')}</FormLabel>
                        <DatePicker
                            sx={{ maxWidth: 160 }}
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'standard' } }}
                            name="EstimStartDt"
                            views={['year', 'month', 'day']}
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            textField={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                />}
                        />
                        <FormHelperText>
                            {'Απαιτείται'}
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl>
                        <FormLabel>{('Description')}</FormLabel>
                        <TimePicker
                            sx={{ maxWidth: 160 }}
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'standard' } }}
                            name="EstimStartDt"
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            renderInput={(props) => <TextField {...props}/>}
                        />
                    </FormControl>
                </Grid>

                <Grid item>
                    <FormControl>
                        <FormLabel>{('Description')}</FormLabel>
                        <DateTimePicker
                            slotProps={{ textField: { size: 'small', variant: 'standard' } }}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl>
                        <FormLabel>{('Description')}</FormLabel>
                        <DateRangePicker
                            slotProps={{ textField: { size: 'small', variant: 'standard' } }}
                            localeText={{
                                start: '',
                                end: '',
                            }}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <h3>Outlined</h3>
            <Grid
                container
                spacing={3}
            >
                <Grid item>
                    <FormControl>
                        <FormLabel>{('Description')}</FormLabel>
                        <DatePicker
                            sx={{ maxWidth: 160 }}
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
                            name="EstimStartDt"
                            views={['year', 'month', 'day']}
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            textField={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                />}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl>
                        <FormLabel>{('Disabled')}</FormLabel>
                        <DatePicker
                            sx={{ maxWidth: 160 }}
                            disabled
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
                            name="EstimStartDt"
                            views={['year', 'month', 'day']}
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            textField={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                />}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl>
                        <FormLabel>{('Read Only')}</FormLabel>
                        <DatePicker
                            sx={{ maxWidth: 160 }}
                            readOnly
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
                            name="EstimStartDt"
                            views={['year', 'month', 'day']}
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            textField={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                />}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl required>
                        <FormLabel>{('Required')}</FormLabel>
                        <DatePicker
                            sx={{ maxWidth: 160 }}
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
                            name="EstimStartDt"
                            views={['year', 'month', 'day']}
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            textField={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                />}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl
                        required
                        error={true}
                    >
                        <FormLabel>{('Error')}</FormLabel>
                        <DatePicker
                            sx={{ maxWidth: 160 }}
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
                            name="EstimStartDt"
                            views={['year', 'month', 'day']}
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            textField={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                />}
                        />
                        <FormHelperText>
                            {'Απαιτείται'}
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl>
                        <FormLabel>{('Description')}</FormLabel>
                        <TimePicker
                            sx={{ maxWidth: 160 }}
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
                            name="EstimStartDt"
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            renderInput={(props) => <TextField {...props}/>}
                        />
                    </FormControl>
                </Grid>

                <Grid item>
                    <FormControl>
                        <FormLabel>{('Description')}</FormLabel>
                        <DateTimePicker
                            slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl>
                        <FormLabel>{('Description')}</FormLabel>
                        <DateRangePicker
                            slotProps={{ textField: { size: 'small', variant: 'outlined' } }}
                            localeText={{
                                start: '',
                                end: '',
                            }}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <h3>Filled</h3>
            <Grid
                container
                spacing={3}
            >
                <Grid item>
                    <FormControl>
                        <FormLabel>{('Description')}</FormLabel>
                        <DatePicker
                            sx={{ maxWidth: 160 }}
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'filled' } }}
                            name="EstimStartDt"
                            views={['year', 'month', 'day']}
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            textField={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                />}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl>
                        <FormLabel>{('Disabled')}</FormLabel>
                        <DatePicker
                            sx={{ maxWidth: 160 }}
                            disabled
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'filled' } }}
                            name="EstimStartDt"
                            views={['year', 'month', 'day']}
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            textField={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                />}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl>
                        <FormLabel>{('Read Only')}</FormLabel>
                        <DatePicker
                            sx={{ maxWidth: 160 }}
                            readOnly
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'filled' } }}
                            name="EstimStartDt"
                            views={['year', 'month', 'day']}
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            textField={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                />}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl required>
                        <FormLabel>{('Required')}</FormLabel>
                        <DatePicker
                            sx={{ maxWidth: 160 }}
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'filled' } }}
                            name="EstimStartDt"
                            views={['year', 'month', 'day']}
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            textField={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                />}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl
                        required
                        error={true}
                    >
                        <FormLabel>{('Error')}</FormLabel>
                        <DatePicker
                            sx={{ maxWidth: 160 }}
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'filled' } }}
                            name="EstimStartDt"
                            views={['year', 'month', 'day']}
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            textField={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                />}
                        />
                        <FormHelperText>
                            {'Απαιτείται'}
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl>
                        <FormLabel>{('Description')}</FormLabel>
                        <TimePicker
                            sx={{ maxWidth: 160 }}
                            id={'EstimStartDt'}
                            slotProps={{ textField: { size: 'small', variant: 'filled' } }}
                            name="EstimStartDt"
                            // inputFormat={dateFormat}
                            // value={formik.values.EstimStartDt}
                            // onChange={(newValue) => handleDate(newValue, 'EstimStartDt')}
                            // onBlur={formik.handleBlur}
                            renderInput={(props) => <TextField {...props}/>}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl>
                        <FormLabel>{('Description')}</FormLabel>
                        <DateTimePicker
                            slotProps={{ textField: { size: 'small', variant: 'filled' } }}
                        />
                    </FormControl>
                </Grid>
                <Grid item>
                    <FormControl>
                        <FormLabel>{('Description')}</FormLabel>
                        <DateRangePicker
                            slotProps={{ textField: { size: 'small', variant: 'filled' } }}
                            localeText={{
                                start: '',
                                end: '',
                            }}
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </Box>
    )
}

export default DateTimePickers